import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  Box,
  Button,
  CircularProgress,
  Chip
} from '@mui/material';
import { supabase } from '../../lib/supabase';
import { format } from 'date-fns';
import { ko } from 'date-fns/locale';
import { useNavigate } from 'react-router-dom';

const SuccessStories = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchStories();
  }, []);

  const fetchStories = async () => {
    try {
      const { data, error } = await supabase
        .from('success_stories')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      setStories(data);
    } catch (error) {
      console.error('합격자 스토리를 불러오는 중 오류 발생:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      {stories.map((story) => (
        <Grid item xs={12} sm={6} md={4} key={story.id}>
          <Card
            elevation={2}
            onClick={() => navigate(`/community/success-stories/${story.id}`)}
            sx={{ cursor: 'pointer' }}
          >
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {story.title}
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
                <Chip 
                  label={`시험일: ${format(new Date(story.exam_date), 'yyyy.MM.dd')}`}
                  size="small"
                />
                <Chip 
                  label={`점수: ${story.exam_score}점`}
                  size="small"
                  color="primary"
                />
                <Chip 
                  label={`공부기간: ${story.study_period}`}
                  size="small"
                />
              </Box>
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  mb: 2
                }}
              >
                {story.content}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {format(new Date(story.created_at), 'PPP', { locale: ko })}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default SuccessStories; 